import script from "./AdminTaskListView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTaskListView.vue?vue&type=script&setup=true&lang=js"

import "./AdminTaskListView.vue?vue&type=style&index=0&id=078ca5ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-078ca5ea"]])

export default __exports__